import React, {useEffect} from 'react';
import styles from "./styles";
import classnames from "classnames";
import {FormattedMessage, useIntl} from "react-intl";
import {Card} from "react-bootstrap";
import {useTheme} from "react-jss";
import RedemptionHistoryFilters, {REDEMPTION_HISTORY_GRID_TYPE} from "./RedemptionHistoryFilters";
import RedemptionHistoryGridHeader from "./RedemptionHistoryGridHeader";
import UCGrid from "components/ucgrid";
import { loyaltyFailureReasons } from 'constants/appConstants';

import ResubmitRedemptionModal from "../modals/resubmitRedemptionModal";
import LoyaltyDeleteFailedModal from "../modals/loyaltyDeleteFailedModal";
import classNames from "classnames";
import {NumericFormat} from "react-number-format";
import moment from "helpers/moment";
import UCButton from "components/buttons";
import {ReactComponent as DownloadIcon} from "resources/images/download-02.svg";
import {useAllotmentBudgetYear} from "services/loyaltyService";

/**
 *
 * @param {Object} props
 * @returns {Element}
 * @constructor
 */
function RedemptionHistory(props) {
  const {
    getLoyaltyList,
    gridOptions,
    setGridOptions,
    redemptionHistoryResponse,
    redemptionHistoryCountResponse,
    getRedemptionHistoryList,
    getRedemptionHistoryCount,
    addRedemption,
    removeFailedRedemptions,
    handleDownloadReport
  } = props;
  const theme = useTheme();
  const classes = styles({theme});
  const intl = useIntl();

  const {allotmentBudgetYear, getAllotmentBudgetYear} = useAllotmentBudgetYear();

  useEffect(() => {
    getAllotmentBudgetYear();
  }, []);


  const updateRedemptionsList = async () => {
    await Promise.all([getRedemptionHistoryList(gridOptions), getRedemptionHistoryCount()])
  }
  const onRowClick = () => {
    //TODO: To be implemented
  }

  const handlePageChange = (page) => {
    setGridOptions(gridOptions => {
      const newGridOptions = {...gridOptions, page};

      getRedemptionHistoryList(newGridOptions);

      return newGridOptions;
    })
  }

  return (<div className={classnames("redemption-history", classes.redemptionHistory)}>
    <Card className={classnames("redemption-history-card", classes.redemptionHistoryCard)}>
      <Card.Header className={classes.redemptionHistoryHeader}>
        <div className={classes.redemptionHistoryHeaderTitleContainer}>
          <Card.Title>
            <FormattedMessage id='redemptionHistory.title'/>
          </Card.Title>
          <Card.Text>
            <FormattedMessage id='redemptionHistory.subtitle'/>
          </Card.Text>
        </div>

        <div className={classes.redemptionHistoryHeaderButtonContainer}>
          {gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.COMPLETED ? <UCButton
            type="default"
            className={
              redemptionHistoryResponse?.results?.dataItems.length !== 0
                ? classes.downloadBtn
                : classes.downloadDisableBtn
            }
            onClick={() => handleDownloadReport(gridOptions)}
            text={<FormattedMessage id="redemptionHistory.buttonDownload"/>}
            icon={<DownloadIcon />}
            iconClassName={
              redemptionHistoryResponse?.results?.dataItems.length !== 0
                ? classes.downloadActiveIcon
                : classes.downloadDisableIcon
            }
            loadingStateStyling={classes.downloadLoadingState}
            spinnerClassName={classes.spinnerStyle}
            spinner={{
              name: "redemptionHistoryDownloadSpinner",
              size: 20,
            }}
            disabled={redemptionHistoryResponse?.results?.dataItems.length === 0}
          /> : null}
        </div>
      </Card.Header>

      <Card.Header className={classes.redemptionHistoryCardHeaderSmall}>
        <RedemptionHistoryFilters
          allotmentBudgetYear={allotmentBudgetYear}
          gridOptions={gridOptions}
          setGridOptions={setGridOptions}
          failureCount={redemptionHistoryCountResponse?.redemptions?.find(r => r.status === REDEMPTION_HISTORY_GRID_TYPE.FAILED)?.count}
          gridData={redemptionHistoryResponse?.results}
          getLoyaltyList={getLoyaltyList}/>
      </Card.Header>
      <Card.Body className={classes.redemptionHistoryCardBody}>
        <UCGrid
          gridName="redemptionHistoryGrid"
          spinner="redemptionHistoryGridSpinner"
          data={redemptionHistoryResponse?.results}
          columns={redemptionHistoryResponse?.columns}
          actions={redemptionHistoryResponse?.actions}
          actionsWidth={gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.FAILED ? "130px" : undefined}
          noDataComponent={<RedemptionHistoryGridHeader gridOptions={gridOptions} setGridOptions={setGridOptions}/>}
          onRowClick={onRowClick}
          handlePageChange={handlePageChange}
          defaultSort={redemptionHistoryResponse?.defaultSort}
          gridMobileWrapperClassName={classNames(classes.gridMobileWrapperClassName)}
          gridWrapperClassName={classes.gridWrapperClassName}
          columnCustomWidth={{
            avatarName: "300px",
            cost: "170px",
            expirationDate: "140px",
            submittedDate: "140px",
            failureReason: "350px",
            membershipNumber: "190px !important",
            tier: "280px",
            nominatedBy: "250px",
          }}
          customColumns={{
            tier: (row) => (<div className={classNames(classes.text, classes.bold)}>
              <FormattedMessage id='redemptionHistory.grid.tier' values={{tier: row.tier}}/>
            </div>),
            expirationDate: (row) => row.expirationDate ?
              <div className={classNames(classes.text)}>{moment(row.expirationDate).format("MM/DD/YYYY")}</div> : '',
            submittedDate: (row) => row.submittedDate ?
              <div className={classNames(classes.text)}>{moment(row.submittedDate).format("MM/DD/YYYY")}</div> : '',
            membershipNumber: (row) => (<div className={classNames(classes.text)}>{row.membershipNumber}</div>),
            nominatedBy: (row) => (<div className={classNames(classes.text)}>{row.nominatedBy}</div>),
            cost: (row) => (<div className={classNames(classes.text)}>
              <NumericFormat
                value={row.cost}
                thousandSeparator=","
                fixedDecimalScale
                displayType="text"
                renderText={(cost) => <p className={classes.loyaltyPointsText}><FormattedMessage
                  id="redemptionHistory.grid.cost" values={{cost}}/></p>}
              />
            </div>),
            failureReason: (row) => (<div className={classNames(classes.text)}>{row.failureReason && intl.formatMessage(loyaltyFailureReasons[row.failureReason])}</div>),
          }}
          avatarNameLink={() => '#'}
          actionsDots={false}
          actionsComponent={
            gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.FAILED ? (row) => (<>
              <ResubmitRedemptionModal row={row} getLoyaltyList={getLoyaltyList} addRedemption={addRedemption}
                                       updateRedemptionsList={updateRedemptionsList}/>
              <LoyaltyDeleteFailedModal row={row} updateRedemptionList={updateRedemptionsList}
                                        getLoyaltyList={getLoyaltyList} removeFailedRedemptions={removeFailedRedemptions}/>
            </>) : undefined}
          handleSort={(column, sortDirection) => setGridOptions({
            ...gridOptions, sortby: column.id, sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
          })}
        />
      </Card.Body>
    </Card>
  </div>);
}

export default RedemptionHistory;